import { StrictMode } from 'react';
import { IntlProvider } from 'react-intl';
import { Outlet } from 'react-router-dom';
import NotificationsContainer from '@rio-cloud/rio-uikit/NotificationsContainer';

import { DEFAULT_LOCALE } from '@/configuration/lang/lang';
import { getDisplayMessages, getLocale } from '@/configuration/lang/langSlice';
import { useAppSelector } from '@/configuration/setup/hooks';
import MessageHandler from './MessageHandler';

import './App.css';

const App = () => {
    const userLocale = useAppSelector(getLocale);
    const displayMessages = useAppSelector(getDisplayMessages);

    if (!displayMessages || !userLocale) {
        return null;
    }

    return (
        <IntlProvider defaultLocale={DEFAULT_LOCALE} key={userLocale} locale={userLocale} messages={displayMessages}>
            <StrictMode>
                <Outlet />
            </StrictMode>
            <MessageHandler />
            <NotificationsContainer />
        </IntlProvider>
    );
};

export default App;
